import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import {
  toggleMode,
  changeTableDateRange,
  filterPeakShavingData
} from "../../actions";

// Material UI
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import { DatePicker } from "@material-ui/pickers";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import { Typography } from "@material-ui/core";

const styles = theme => ({
  list: {
    width: 250
  },
  filters: {
    width: "auto"
  },
  title: {
    marginLeft: theme.spacing(3)
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: theme.spacing(7)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200
  },
  button: {
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(7)
  }
});

class TemporaryDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      startDate: '',
      endDate: '',
      maxPkEnergy: 0
    };
  }

  componentDidMount = () => {
    const { tableDateRange: { startDate, endDate } } = this.props;
    this.setState({
      startDate: startDate.format(),
      endDate: endDate.format()
    });
  };

  componentDidUpdate = prevProps => {
    if (this.props.mode.realtime !== prevProps.mode.realtime) {
      if (this.props.mode.realtime) {
        this.setState({
          startDate: moment().subtract(1, 'day').format(),
          endDate: moment().format()
        });
      }
    }
  };

  /*handleStartDateChange = date => {
    this.setState({ startDate: date.format() });
  };*/

  handleEndDateChange = date => {
    const targetEndDate = date.endOf('day');

    const diff = date.diff(moment(), 'second');

    if (diff >= 0) {
      this.setState({
        startDate: moment().subtract(1, 'day').format(),
        endDate: moment().format(),
      });
    } else {
      this.setState({
        startDate: targetEndDate.clone().subtract(1, 'day').format(),
        endDate: targetEndDate.format(),
      });
    }
  };

  handleFilterChange = event => {
    this.setState({ [event.target.name]: event.target.value });
    this.props.mode.realtime && this.props.toggleMode();
  };

  handleSubmitFilters = e => {
    const { startDate, endDate, maxPkEnergy } = this.state;
    const { mode: { realtime } } = this.props;

    if (realtime) {
      this.props.toggleMode();
    }

    if (!maxPkEnergy) {
      this.setState({ maxPkEnergy: 0 });
    }

    const maxPkEnergyInt = parseInt(maxPkEnergy, 10) || 0;

    this.props.filterPeakShavingData(maxPkEnergyInt);
    this.props.changeTableDateRange({ startDate: moment(startDate), endDate: moment(endDate) });

    this.props.toggleDrawer();

    // const filteredData = this.props.table.updatedData.filter(item => {
    //   const time = item.timestamp || item.start;
    //   const startUnix = moment(startDate).unix() * 1001;
    //   const endUnix = moment(endDate).unix() * 1001;
    //   if (item.customer_peak_max_kwh) {
    //     return (
    //       item.customer_peak_max_kwh > maxPkEnergyInt &&
    //       inRange(time, startUnix, endUnix)
    //     );
    //   }
    //   return inRange(time, startUnix, endUnix);
    // });
    // this.props.updateDisplayedData(filteredData);
  };

  render() {
    const { classes, open, toggleDrawer } = this.props;
    const { endDate } = this.state;

    const filters = (
      <div className={classes.list}>
        <Typography className={classes.title} variant="h5" gutterBottom>
          Available Filters
        </Typography>
        <Divider/>

        <form className={classes.container} noValidate>
          <List>
            {/*<ListItem>
              <DatePicker
                autoOk
                name="startDate"
                label="Start Date"
                value={this.state.startDate}
                format="DD/MM/YYYY"
                onChange={date => this.handleStartDateChange(date)}
              />
            </ListItem>*/}
            <ListItem>
              <DatePicker
                autoOk
                name="endDate"
                label="Date"
                //disableFuture
                value={endDate}
                format="DD/MM/YYYY"
                onChange={date => this.handleEndDateChange(date)}
              />
            </ListItem>
            {/* <ListItem>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.props.mode.realtime}
                    color="secondary"
                    onChange={this.props.toggleMode}
                  />
                }
                label="Realtime Mode"
              />
            </ListItem> */}
            {/*<Divider/>*/}
            {/*<ListItem>
              <TextField
                name="maxPkEnergy"
                id="outlined-name"
                label="Max Peak Energy"
                className={classes.textField}
                placeholder="kWh"
                value={this.state.maxPkEnergy}
                onChange={this.handleFilterChange}
                margin="normal"
                variant="outlined"
              />
            </ListItem>*/}
          </List>
          <Button
            variant="contained"
            id="filter-button"
            className={classes.button}
            onClick={this.handleSubmitFilters}
          >
            Filter
          </Button>
        </form>
        {/* <List>
          {["All mail", "Trash", "Spam"].map((text, index) => (
            <ListItem button key={text}>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List> */}
      </div>
    );

    return (
      <div>
        <Drawer open={open} onClose={toggleDrawer}>
          <div tabIndex={0} role="button">
            {filters}
          </div>
        </Drawer>
      </div>
    );
  }
}

TemporaryDrawer.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    tableDateRange: state.tableDateRange,
    mode: state.mode,
    table: state.table
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    { changeTableDateRange, toggleMode, filterPeakShavingData }
  )(TemporaryDrawer)
);



// WEBPACK FOOTER //
// ./src/components/drawer/TemporaryDrawer.js